import { CookieTypes } from '../CookieTypes'
import { useEffect } from 'react'
import { Link } from '@remix-run/react'
import { CloseIcon } from '~/components/icons'
import { Button } from '~/components/general/Button'
import { trackEvent } from '~/utils/tracking/trackEvent'

export type cookieModalProps = {
  closeModal: (value: boolean) => void
  handleAccept: () => void
  handleToggle: (cookieType: string) => void
  CookieConsent: Array<string>
  handleSavePreferences: () => void
}

export const ModalContent = ({
  closeModal,
  handleAccept,
  CookieConsent,
  handleToggle,
  handleSavePreferences,
}: cookieModalProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <div
      className="flex z-10 fixed left-0 top-0 w-full h-full justify-center overflow-auto flex-col"
      style={{ backgroundColor: 'rgba(15, 20, 30, 0.9)' }}
    >
      <div
        className="bg-white absolute h-[688px] w-[736px] lg:top-12 top-0 p-0 pb-10 flex flex-col gap-5 cursor-pointer lg:rounded-3xl max-md:w-full lg:translate-x-1/2"
        style={{
          boxShadow:
            'rgba(15, 56, 113, 0.08) 0px 2px 4px -1px, rgba(15, 56, 113, 0.12) 0px 8px 20px -4px',
        }}
      >
        <div
          className="flex justify-between items-center p-3 pl-7 gap-2 h-19 flex-none self-stretch flex-grow-0 border-b border-neutral-20"
          style={{ boxSizing: 'border-box' }}
        >
          <p className="text-neutral-100 text-s">Protect your data</p>

          <button
            className="flex justify-center items-center p-0 gap-2 w-13 h-13 rounded-[100px] flex-none flex-grow-0 border-none bg-transparent cursor-pointer hover:bg-neutral-5"
            onClick={() => closeModal(false)}
          >
            <CloseIcon className="w-6 h-6 lg:w-[30px] lg:h-[30px] text-black" />
          </button>
        </div>

        <div className="flex flex-col flex-grow-0 pt-0 px-7 pb-4 max-lg:pb-7 w-[736px] h-[582px] max-lg:w-[720px] max-lg:h-[510px] max-md:w-auto max-md:h-full max-md:px-5 max-md:pb-20 max-lg:gap-8 max-md:gap-7 items-start gap-10 flex-none order-1 self-stretch overflow-y-auto overflow-x-hidden bg-white">
          <div className="flex flex-col items-start p-0 gap-5 h-auto flex-none self-stretch max-w-[680px] flex-grow-0 max-lg:gap-4 max-lg:h-auto max-lg:max-w-[664px] max-md:min-h-auto max-md:w-auto">
            <div className="flex flex-col p-0 gap-3 max-w-[680px] h-auto self-stretch items-start flex-none flex-grow-0 max-md:w-auto max-lg:w-[664px]">
              <p className="h-auto font-tt_talent max-lg:h-auto max-md:w-auto text-xs w-[664px] flex-grow-0 self-stretch flex-none max-w-[680px] text-[#0F141E]">
                We use cookies to provide our services, improve the user experience, for analysis
                and marketing purposes. By giving your consent, you also agree that your data may be
                transferred to the USA by the use of cookies.You can revoke your consent at any
                time.You can find further information in our{' '}
                <Link
                  className="text-blue-50"
                  to="https://career.io/privacy"
                  target="_blank"
                  onClick={() => {
                    trackEvent('click_cookie_banner', {
                      website_host: 'career.io',
                      label: 'click_cookie_banner',
                      cta_text: 'privacy policy',
                      url: 'https://career.io/privacy',
                    })
                  }}
                >
                  privacy policy
                </Link>{' '}
                and{' '}
                <Link
                  className="text-blue-50"
                  to="https://career.io/cookie-policy"
                  target="_blank"
                  onClick={() => {
                    trackEvent('click_cookie_banner', {
                      website_host: 'career.io',
                      label: 'click_cookie_banner',
                      cta_text: 'cookie policy',
                      url: 'https://career.io/cookie-policy',
                    })
                  }}
                >
                  cookie policy
                </Link>
                .
              </p>
            </div>
            <div className="m-0 inline-flex">
              <Button text={'Accept All'} onClick={handleAccept} className={'w-fit'} />
            </div>
          </div>
          <div className="flex flex-col items-start p-0 xl:gap-6 xl:w-[680px] flex-none self-stretch flex-grow-0 h-auto lg:w-[664px] gap-5 w-auto">
            <CookieTypes CookieConsent={CookieConsent} handleToggle={handleToggle} />
            <div className="m-0 inline-flex">
              <Button
                color={'transparent'}
                text={'Save Preferences'}
                onClick={() => handleSavePreferences()}
                className={'w-fit !border !border-[#E7EAF4] !text-[#0F141E] !hover:!text-[#0F141E]'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
